<div class="pdf-modal" *ngIf="showFrame" (click)="closePdfModal()">
  <div class="pdf-modal-content" (click)="$event.stopPropagation()">
    <div class="pdf-header card-header card-header-info">
      <h5 class="card-title">
        <span *ngIf="mimeType?.startsWith('image/')">{{ 'texto_945' | translate }}</span>
        <span *ngIf="!mimeType?.startsWith('image/')">{{ 'texto_927' | translate }}</span>
      </h5>
      <button class="close-btn" (click)="closePdfModal()">&times;</button>
    </div>

    <div class="pdf-body">

      <!-- Imagen -->
      <img
        *ngIf="mimeType?.startsWith('image/')"
        [src]="safeUrl"
        alt="Vista previa de imagen"
        class="file-preview-image"
      />

      <!-- Video -->
      <video
        *ngIf="mimeType?.startsWith('video/')"
        [src]="safeUrl"
        controls
        class="file-preview-video"
      ></video>

      <!-- Audio -->
      <audio
        *ngIf="mimeType?.startsWith('audio/')"
        [src]="safeUrl"
        controls
        class="file-preview-audio"
      ></audio>

      <!-- PDF -->
      <iframe
        *ngIf="mimeType == 'application/pdf'"
        [src]="safeUrl"
        title="Vista previa de archivo"
        frameborder="0"
      ></iframe>

      <!-- Text plain or HTML -->
      <iframe
      *ngIf="mimeType?.startsWith('text/') && mimeType !== 'text/html'"
      [src]="safeUrl"
      title="Vista previa de texto"
      frameborder="0"
      ></iframe>

      <!-- No mimetype-->
      <iframe
        *ngIf="!mimeType"
        [src]="safeUrl"
        title="Vista previa de archivo"
        frameborder="0"
      ></iframe>

    </div>
  </div>
</div>


